import React, { Component, Fragment } from "react";
import { Checkbox, InputNumber } from "antd";
import {
	MatrixContainer,
	MatrixProduct,
	KpiMatrixLabel,
	KpiInputNumber,
	ProductContainer,
	ProductTitle,
	QuestionProductLabel,
} from "./../../../../StyledComponents";
import { Radio } from "antd/lib/radio";
import { MatrixProductList } from "./../../../../StyledComponents";

const Matrix = props => {
	const {
		categories,
		kpis,
		ltN,
		lN,
		sN,
		setResponse,
		statement,
		kpiPage,
	} = props;

	const handleChangeAnswer = (value, ltN, lN, sN, k, p) => {
		setResponse(value, ltN, lN, sN, k, p);
	};

	const buildProductsView = () => {
		//const products= [];
		const cellStyle = {
			width: "25%",
			display: "inline-block",
			textAlign: "center",
		};

		const kpisDisplayed = [];
		for (let i = 0; i < kpis.length; i++) {
			const kpi = kpis[i];
			if (kpi && kpi.survey_display) {
				kpisDisplayed.push(kpi);
			}
		}
		let kpisPage = [];
		const kpiIndex = kpiPage * 3;
		for (let i = kpiIndex; i < kpiIndex + 3; i++) {
			const kpi = kpisDisplayed[i];
			if (kpi) {
				kpisPage.push(kpi);
			}
		}
		return (
			<Fragment>
				<div>
					<div style={{ width: "25%", display: "inline-block" }} />
					{kpisPage.map((kpi, k) => {
						return !!kpi.survey_display ? (
							<Fragment key={k}>
								<div
									style={{
										...cellStyle,
										textAlign: "center",
										fontSize: "0.6vw",
										padding: 5,
									}}
								>
									{kpi.long_label}
								</div>
							</Fragment>
						) : null;
					})}
				</div>

				<div className="p-survey-simulation-phone-matrix">
					{categories.map((category, c) => {
						return (
							<Fragment key={c}>
								{category.families.map((family, c) => {
									return (
										<Fragment key={c}>
											{family.brands.map((brand, c) => {
												return (
													<Fragment key={c}>
														{brand.products.map((product, p) => {
															return (
																<div
																	key={p}
																	className="matrix"
																	style={{
																		display: "flex",
																		alignItems: "center",
																		marginBottom: 15,
																	}}
																>
																	<div
																		style={{
																			...cellStyle,
																			textAlign: "left",
																			fontSize: "0.7vw",
																		}}
																	>
																		{product.label}
																	</div>
																	{kpisPage.map((kpi, k) => {
																		return !!kpi.survey_display ? (
																			<Fragment key={k}>
																				{(function() {
																					switch (kpi.format) {
																						case "Num":
																							return (
																								<div
																									style={{
																										...cellStyle,
																										height: "100%",
																									}}
																								>
																									<KpiInputNumber
																										className="matrixInput"
																										key={`${product.ean}${k}`}
																										value={
																											statement.kpis[k].response
																												? statement.kpis[k]
																														.response[
																														product.ean
																												  ]
																												: ""
																										}
																										onChange={value =>
																											handleChangeAnswer(
																												parseInt(value),
																												ltN,
																												lN,
																												sN,
																												k,
																												product.ean
																											)
																										}
																										min="0"
																									/>
																								</div>
																							);
																						case "Boolean":
																							return (
																								<div
																									style={{
																										...cellStyle,
																										height: "100%",
																									}}
																								>
																									<Checkbox
																										onChange={event =>
																											handleChangeAnswer(
																												event.target.checked,
																												ltN,
																												lN,
																												sN,
																												k,
																												product.ean
																											)
																										}
																										id={`${p}${k}1`}
																										checked={
																											statement.kpis[k]
																												.response &&
																											statement.kpis[k]
																												.response[product.ean]
																												? true
																												: false
																										}
																									/>
																								</div>
																							);
																						default:
																							return null;
																					}
																				})()}
																			</Fragment>
																		) : null;
																	})}
																</div>
															);
														})}
													</Fragment>
												);
											})}
										</Fragment>
									);
								})}
							</Fragment>
						);
					})}
				</div>
			</Fragment>
		);
	};

	return <Fragment>{buildProductsView()}</Fragment>;
};

export default Matrix;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/Matrix/Matrix.js